import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import { TwoColumnLayoutService } from 'src/app/common-components/column-layouts/two-column-list-layout/services/selected-id.service';
import { LcsDialogService } from 'src/app/common-components/dialog/dialog.service';
import { getSelectedAccountId } from 'src/app/store/select-account/select-account.selector';
import { DepartmentDetailSaveModel } from '../../department-details/models/department-detail-save.model';
import { AddDepartmentApiService } from '../services/add-department-api.service';
import * as AddDepartmentActions from './add-department.actions';

@Injectable()
export class AddDepartmentEffects {
   createDepartment$ = createEffect(() => {
      return this.actions$.pipe(
         ofType(AddDepartmentActions.createDepartment),
         withLatestFrom(this.store.select(getSelectedAccountId)),
         switchMap(([action, accountId]) => {
            const departmentToSave: DepartmentDetailSaveModel = {
               ...action.department,
               accountId: accountId ?? 0,
            };
            return this.addDepartmentApiService.create(departmentToSave).pipe(
               map((executionResult) => {
                  return AddDepartmentActions.createDepartmentSuccess({
                     departmentId: executionResult.data.department.departmentId,
                     departmentName: executionResult.data.department.name,
                  });
               }),
               catchError((error) => {
                  return of(AddDepartmentActions.createDepartmentFailure(error));
               })
            );
         })
      );
   });

   createDepartmentSuccess$ = createEffect(
      () => {
         return this.actions$.pipe(
            ofType(AddDepartmentActions.createDepartmentSuccess),
            tap((result) => {
               this.dialogService.closeFormComponent();
               // Call newItemAdded to set selectedId to new departmentId and notify register component of new item (will refresh list)
               this.twoColumnLayoutService.newItemAdded(result.departmentId);
               this.snackbar.open(`Department ${result.departmentName} Created`);
            })
         );
      },
      {
         dispatch: false,
      }
   );

   constructor(
      private actions$: Actions,
      private addDepartmentApiService: AddDepartmentApiService,
      private store: Store,
      private snackbar: MatSnackBar,
      private dialogService: LcsDialogService,
      private twoColumnLayoutService: TwoColumnLayoutService
   ) {}
}
